import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { NgxImageCompressService } from "ngx-image-compress";
import { Observable } from "rxjs/internal/Observable";
import { Subscription } from "rxjs/internal/Subscription";
import { ImageUpload } from "src/app/interfaces/helpers";

@Component({
  selector: "image-upload",
  templateUrl: "./image-upload.component.html",
})
export class ImageUploadComponent implements OnInit, OnDestroy {
  @Input() lines: string = "none";
  @Input() includePreview: boolean = false;
  @Input() label: string = "IMAGE";
  @Input() inputId: string = "file-input";

  private clearSub: Subscription;
  @Input() clearInput: Observable<void>;

  image: ImageUpload = { loaded: false, blob: null };
  inputTag = "UPLOAD_IMAGE";
  @Output() imageToUpload = new EventEmitter<ImageUpload>();

  constructor(private imageCompress: NgxImageCompressService) {}

  ngOnInit(): void {
    if (this.clearInput) {
      this.clearSub = this.clearInput.subscribe(() => {
        this.inputTag = "UPLOAD_IMAGE";
        this.imageToUpload.emit(null);
      });
    }
  }

  ngOnDestroy(): void {
    if (this.clearSub) {
      this.clearSub.unsubscribe();
    }
  }

  loadImageFromDevice(event) {
    const file = event?.target?.files?.[0];
    if (!file) {
      return;
    }

    this.inputTag = file.name;
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const MAX_WIDTH = 640;
      const MAX_HEIGHT = 640;
      let width = img.width;
      let height = img.height;

      if (width > MAX_WIDTH || height > MAX_HEIGHT) {
        if (width > height) {
          height *= MAX_WIDTH / width;
          width = MAX_WIDTH;
        } else {
          width *= MAX_HEIGHT / height;
          height = MAX_HEIGHT;
        }
      }

      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;

      if (!ctx) {
        return;
      }

      ctx.drawImage(img, 0, 0, width, height);

      canvas.toBlob((blob) => {
        if (!blob) {
          return;
        }

        const compressedImage = new File([blob], file.name, {
          type: file.type,
        });
        this.image.blob = compressedImage;
        this.image.loaded = true;
        this.image.file = compressedImage;

        if (this.includePreview) {
          setTimeout(() => {
            document
              .getElementById("imgPreview")
              .setAttribute("src", URL.createObjectURL(compressedImage));
          }, 1000);
        }

        this.imageToUpload.emit(this.image);
      }, file.type);
    };

    img.onerror = (error) => {
      console.log(error);
    };
  }

  async resizeImage(image: File, newWidth: number): Promise<File> {
    return new Promise<File>((resolve) => {
      const img = new Image();
      img.onload = () => {
        const aspectRatio = img.width / img.height;
        const newHeight = newWidth / aspectRatio;

        const canvas = document.createElement("canvas");
        canvas.width = newWidth;
        canvas.height = newHeight;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        canvas.toBlob(
          (blob) => {
            const resizedImage = new File([blob], image.name, {
              type: "image/jpeg",
            });
            resolve(resizedImage);
          },
          "image/jpeg",
          1,
        ); // Calidad fija para la imagen redimensionada
      };

      const reader = new FileReader();
      reader.onload = (event) => {
        if (event.target && event.target.result) {
          img.src = event.target.result as string;
        }
      };

      reader.readAsDataURL(image);
    });
  }
}
